import { Circle } from '@chakra-ui/react';
import {
  Box,
  Flex,
  FlexProps,
  Spinner,
  TapTheme,
} from '@tapresearch/ui/components';
import React from 'react';
import { useGetCampaignHealthStatusQuery } from '../store/api';
import { getCampaignHealthStatus } from '../store/campaigns/selectors/getCampaignHealthStatus';
import { useAppSelector } from '../store/hooks';

const statusColor = {
  Pass: TapTheme.colors.green[500],
  Ok: TapTheme.colors.green[500],
  Minor: TapTheme.colors.orange[200],
  Serious: TapTheme.colors.orange[700],
  Critical: TapTheme.colors.red[500],
};

const statusIndex = {
  Pass: 0,
  Ok: 1,
  Minor: 2,
  Serious: 3,
  Critical: 4,
};

export interface CampaignHealthStatusProps extends FlexProps {
  campaignId: number;
  disabled?: boolean;
}

export function CampaignHealthStatus({
  campaignId,
  disabled = false,
  ...flexProps
}: CampaignHealthStatusProps) {
  const { isLoading } = useGetCampaignHealthStatusQuery(
    {
      id: campaignId.toString(),
    },
    {
      pollingInterval: window.tapiConfig.requests.healthStatus.pollingInterval,
      skip: disabled,
    }
  );

  const healthStatus = useAppSelector((state) =>
    getCampaignHealthStatus(state, campaignId)
  );

  const showLoading = isLoading && !healthStatus;

  return (
    <Flex {...flexProps}>
      {showLoading ? (
        <Spinner data-testid="health-status-loading" size="sm" />
      ) : (
        <Circle
          size={4}
          backgroundColor={
            disabled ? TapTheme.colors.gray[500] : statusColor[healthStatus]
          }
          data-testid={`health-status-${healthStatus}`}
        >
          <Box display="none"> {statusIndex[healthStatus]} </Box>
        </Circle>
      )}
    </Flex>
  );
}
